export function latestWorkUndoTarget(checkpoints = []) {
  const list = checkpoints.filter(item => item?.sha), latest = list.at(-1);
  if (!latest) return null;
  for (let i = list.length - 2; i >= 0; i--) {
    const item = list[i];
    if (item.sha === latest.sha) continue;
    if (latest.kind === 'restore' ? item.kind === 'pre-restore' : item.kind === 'turn' && item.turn < latest.turn) return item;
  }
  return null;
}

export async function openWorkUndo({ taskId, platform, getState, modals, onError, onRestored }) {
  const task = getState().tasks[taskId];
  if (task?.localProject?.bindingId) {
    if (platform !== 'macos') throw new Error('Open this task on its connected Mac to review and undo project edits.');
    modals.openModal('ProjectChangesModal', { taskId, initialIntent: 'undo-turn' });
    return;
  }
  if (['queued', 'running', 'awaiting_input'].includes(task?.status)) throw new Error('Stop or finish this task before undoing its workspace changes.');
  const target = latestWorkUndoTarget(await getState().fetchCheckpoints(taskId, { force: true }));
  if (!target) throw new Error('No earlier workspace checkpoint is available for this task.');
  let applying = false;
  modals.openModal('ConfirmationModal', { title: 'Undo the last workspace change?',
    message: `Restore the saved workspace from turn ${target.turn}? The current workspace is checkpointed first so this restore can also be undone.`,
    confirmText: 'Undo workspace changes', isDanger: true,
    onConfirm: async () => {
      if (applying) return; applying = true;
      try {
        if (['queued', 'running', 'awaiting_input'].includes(getState().tasks[taskId]?.status)) throw new Error('The task resumed. Stop it before restoring files.');
        await getState().restoreCheckpoint(taskId, target); modals.closeModal(); await onRestored?.();
      } catch (error) { onError?.(error.message); }
      finally { applying = false; }
    },
  });
}
